import React from "react";
import { motion } from "framer-motion";
import {
  Trophy,
  Swords,
  Briefcase,
  Crown,
  Rocket,
  ClipboardCheck,
  Target,
  Flame,
} from "lucide-react";
import { useLang } from "../i18n/LangContext";

const ICONS = [Trophy, Swords, Briefcase, Crown, Rocket, ClipboardCheck, Target, Flame];

export const Audiences = () => {
  const { t } = useLang();
  const items = t("audiences.items");

  return (
    <section
      data-testid="section-audiences"
      className="relative py-24 lg:py-32 bg-black"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-primary-red" />
            <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-zinc-400">
              {t("audiences.eyebrow")}
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight">
            {t("audiences.title")}
          </h2>
          <p className="mt-6 font-body text-base lg:text-lg text-zinc-400 leading-relaxed">
            {t("audiences.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 lg:gap-4">
          {items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                data-testid={`audience-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.04 }}
                className="group relative border border-white/10 hover:border-primary-red/70 bg-[#080808] hover:bg-[#0d0d0d] p-6 lg:p-8 transition-colors cursor-default"
              >
                <div className="w-10 h-10 rounded-full border border-white/10 group-hover:border-primary-red flex items-center justify-center mb-6 transition-colors">
                  <Icon size={16} className="text-zinc-300 group-hover:text-primary-red transition-colors" />
                </div>
                <div className="font-display text-base lg:text-lg font-semibold text-white tracking-tight">
                  {it}
                </div>
                <div className="absolute top-3 right-4 text-[10px] font-bold text-zinc-700 tracking-widest">
                  0{i + 1}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
